import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import React from 'react';
import PropTypes from 'prop-types';
import { ListHeader, Tabs, Tab, CashDeskTab, EmployeeBalanceTab, useUser } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerCashDesk = function PartnerCashDesk(_ref) {
  var match = _ref.match;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0441\u043A\u0430 \u043A\u0430\u0441\u0430"
  }), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    contentClass: "container-xxl",
    listClass: "container-xxl",
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/cash-desk",
    component: CashDeskTab,
    label: "\u041A\u0430\u0441\u0430"
  }), ((roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isPartnerManager) || (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant)) && ___EmotionJSX(Tab, {
    url: "/employee-balance",
    component: EmployeeBalanceTab,
    label: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0441\u043B\u0443\u0436\u0438\u0442\u0435\u043B\u0438"
  })));
};

PartnerCashDesk.propTypes = {
  match: PropTypes.object
};
export default PartnerCashDesk;